import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Services } from './components/Services';
import { Team } from './components/Team';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen bg-night-900 font-sans text-pearl selection:bg-gold selection:text-night-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainPoints data-id="element-4" />
        <Services data-id="element-5" />
        <Team data-id="element-6" />
        <Testimonials data-id="element-7" />
        <FinalCTA data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
      <WhatsAppButton data-id="element-10" />
    </div>;
}